import type { tTaskClaim } from "@/types";
import { TaskClaimsCacheService } from "./cache";

export const TaskClaimsMutationHandler = {
  claimCreated(data: { claim: tTaskClaim }) {
    TaskClaimsCacheService.addClaim(data.claim);
  },
  claimUpdated(data: { claim: tTaskClaim }) {
    TaskClaimsCacheService.replaceClaim(data.claim);
  },
  claimRemoved(data: { claim: tTaskClaim }) {
    TaskClaimsCacheService.removeClaim(data.claim);
  },
};
